import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEjercicioContable = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'ejercicio_contable',
        name: 'Ejercicio Contable',
        component: ViewEjercicioContable,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
